module.exports = __webpack_public_path__ + "static/media/consulting_and_reviewing_documents.6da94950.svg";